// extracted by mini-css-extract-plugin
export var modal = "_gt-0";